import { useTranslation } from "react-i18next";
import { Flex, Group, Image } from "@mantine/core";
import { CampaignQueryDataType } from "src/hooks/campaigns";

import { FormItem } from "../../../../FormItem";

export interface ImagesProps {
    campaign: CampaignQueryDataType;
}

export const Images = ({ campaign }: ImagesProps) => {
    const { t } = useTranslation(["common"]);

    return (
        <Flex>
            <FormItem label={t("campaign_images")} style={{ flex: 1 }}>
                <Group mt="md">
                    {(campaign?.images || []).map((image, index) => (
                        <Image
                            key={`${index}${image?.file?.id}`}
                            src={image?.file?.src + "?w=400"}
                            width={200}
                            height={200}
                            style={{ cursor: "pointer" }}
                        />
                    ))}
                </Group>
            </FormItem>
        </Flex>
    );
};
